import { createRouter, createWebHistory } from 'vue-router';
import AuthService from '@/services/AuthService';

// Import views
import Home from '@/views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/confidential',
    name: 'ConfidentialFiles',
    component: () => import('@/views/ConfidentialFiles.vue')
  },
  {
    path: '/verdicts',
    name: 'CourtVerdicts',
    component: () => import('@/views/CourtVerdicts.vue')
  },
  {
    path: '/stories',
    name: 'BackgroundStories',
    component: () => import('@/views/BackgroundStories.vue')
  },
  {
    path: '/document/:id',
    name: 'DocumentDetail',
    component: () => import('@/views/DocumentDetail.vue'),
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/Admin.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'AdminDocuments' }
      },
      {
        path: 'documents',
        name: 'AdminDocuments',
        component: () => import('@/views/admin/Documents.vue')
      },
      {
        path: 'document/new',
        name: 'AdminNewDocument',
        component: () => import('@/views/admin/DocumentForm.vue')
      },
      {
        path: 'document/edit/:id',
        name: 'AdminEditDocument',
        component: () => import('@/views/admin/DocumentForm.vue'),
        props: true
      },
      {
        path: 'test-upload',
        name: 'TestUpload',
        component: () => import('@/views/admin/TestUpload.vue')
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 如果需要认证，检查用户是否已登录
    if (!AuthService.isLoggedIn()) {
      // 未登录，重定向到登录页面
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存原始请求路径，登录成功后重定向回来
      });
    } else {
      // 已登录，允许访问
      next();
    }
  } else {
    // 不需要认证的路由，直接放行
    next();
  }
});

export default router;
